<template>
  <div class="all">
    <div class="password">
      <div class="Verification">
        <div class="code">升级您的专属账号</div>
        <div class="el-input">
          <input type="text" maxlength="10" class="codeInput" v-model="yourName" autocomplete="off" placeholder="姓名">
          <input type="text" maxlength="11" class="codeInput" v-model="yourPhone" autocomplete="off" placeholder="手机号">
          <select class="codeInput" v-model="yourNeed">
            <option value="企业内部采购选型">企业内部采购选型</option>
            <option value="集成商或软件公司采购选型">集成商或软件公司采购选型</option>
            <option value="个人了解学习">个人了解学习</option>
          </select>
          <input class="codeInput2" type="checkbox" v-model="yourSpeed"><label class="codeInput3">需要客服尽快主动与我联系，详细介绍产品和方案</label>
        </div>
        <div class="ok" @click="open()">提交</div>
        <!-- <el-button type="text" @click="open">点击打开 Message Box</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/7/8 12:54 下午
 */
import router from '@/router'
import backChart from '../createScreen/charts/backChart.vue'
import VueDragResize from 'vue-drag-resize';
import charts from '../createScreen/charts/charts'
import {
  SubEmail,
} from '@/assets/axios/mail/mail'
import modules from '../charts/script/modules'

export default {
  name: 'fullScreen',
  components: {
    VueDragResize,
    charts,
    backChart,
  },
  props: {
    name: {
      type: String,
      default: ''
    },
  },
  watch: {},
  data() {
    return {
      userData: {},
      yourPhone: "",
      yourName: "",
      yourNeed: "",
      yourSpeed: "",
      captchaID: "",
      rotationTime: "",//秒数
      nextScreen: true,//下一张大屏id
      show: false,
      //id
      viewScree: {
        //模版id
        modeId: '',
        //大屏id
        viewDPId: ''
      },
      chartList: [],
      pageSize: {
        width: 0,
        height: 0
      },
      //自适应宽高
      adapt: false,
      //全屏
      fullScreen: true,
    }
  },
  methods: {
    async init() {
      let viewDPId = this.$route.params.id;
      let viewDPType = this.$route.params.type;

      $('#ff_body').css({ 'min-width': 'auto' });
      if (viewDPType === '1') {
        this.adapt = true;
      }
      this.userData = localStorage.getItem('user_data')
      this.userData = JSON.parse(this.userData)
      this.yourName = this.userData.userName
      this.yourPhone = this.userData.phone
    },
    open() {
      if (this.yourName && this.yourPhone && this.yourNeed) {
        SubEmail({
          SubName: this.yourName,
          SubPhone: this.yourPhone,
          SubType: this.yourNeed,
        }).then(async res => {
          if (res.code == 200) {
            this.$alert('已经收到您的需求信息，工作人员将于近日与您取得联系，沟通具体需求、报价、方案等事宜!软件分为免费试用版和商用版，免费试用版享有全部功能，但限制时间，而商业版无限制。商业版按功能点、开通时间、 项目实施收费，一般几w 几十w左右(买断制)。如急需咨询，可拨打13866668888详询。', '恭喜，提交成功！', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
        });
      }
    }
  },
  computed: {
    //公共的参数
    nowChart() {
      return this.$store.state.designer.nowChart;
    },
    vuex() {
      return this.$store.state.designer;
    },
    allData: {
      get() {
        return JSON.parse(JSON.stringify(this.vuex.defaultVal.pageParam));
      },
      set(data) {
        return data
      }
    },
    config() {
      return this.option.setting.params;
    },
  },
  created() {
  },
  mounted() {
    this.init();
    $(window).off('resize');
    $(window).on('resize', () => {
      if (this.adapt) {
        this.getInnerHeight('.screen_page_chart');
      }
    });
  },
  async beforeDestroy() {
    $('#ff_body').css({ 'min-width': '1000px' });
    await this.$store.dispatch('clearDesigner');
  }
}
</script>

<style lang="less">
.password {
  width: 100%;
  height: 100%;
  background: url("../../../../public/image/login_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;

  .Verification {
    width: 500px;
    height: 380px;
    padding: 30px;
    background: url("../../../../public/image/register_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-250px) translateY(-150px);

    .code {
      margin: 0 auto;
      text-align: left;
      font-size: 22px;
      color: #00fefe;
    }

    .el-input {
      width: 100%;
      position: relative;
      font-size: 14px;
      display: inline-block;
      margin: 20px 0;

      .codeInput {
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        font-size: 14px;
        border-radius: 2px;
        border: solid 1px #00fdfe;
        background: rgba(0, 253, 254, 0.2);
        color: #fff;
        outline: none;
        margin: 10px 0;

        option {
          color: #000;
          height: 50px;
        }
      }

      .codeInput2 {
        vertical-align: -1px;
      }

      .codeInput3 {
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        font-size: 14px;
        color: #fff;
        outline: none;
        margin: 10px 0;
      }
    }

    .ok {
      background: #00fdfe;
      border-radius: 2px;
      font-size: 16px;
      color: #000;
      letter-spacing: 2px;
      font-weight: 500;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      float: right;
      cursor: pointer;
    }

    .ok:hover {
      opacity: 0.9;
    }
  }
}

.fullScreen {
  width: 100%;
  height: 100%;

  .hover_top_nav {
    position: absolute;
    top: 0;
    right: 20px;
    height: 40px;
    z-index: 9999;
    width: 400px;

    > div {
      display: inline-block;
      width: 100%;
      height: 100%;
      background: transparent;
      text-align: right;
      padding: 0 20px;
      line-height: 40px;

      .top_all {
        display: inline-block;
      }
    }
  }

  .hover_top_nav:hover {
    > div {
      display: inline-block;
      height: 100%;
      width: 100%;
      background: transparent;
      text-align: right;
      padding: 0 20px;
      line-height: 40px;

      .top_all {
        display: inline-block;
      }
    }
  }

  .el-scrollbar {
    width: 100%;
    height: 100%;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .canvasScrollbar {
    overflow: hidden;
  }

  .screen_page_chart {
    overflow: hidden;
    position: relative;
    // animation: scrollOne 3s 1;
    // animation-fill-mode: forwards;
    // animation-delay: 2s; //延迟时间(默认值为0)
  }

  // @keyframes scrollOne {
  //   0% {
  //     opacity: 1;
  //   }
  //   100% {
  //     opacity: 0;
  //   }
  // }
}

// .red {
//   background: skyblue;
//   position: absolute;
//   overflow: hidden;
//   top: 0;
//   left: 0;
//   opacity: 0;
//   animation: scroll 3s 1;
//   animation-fill-mode: forwards;
//   animation-delay: 2s; //延迟时间(默认值为0)
// }
// @keyframes scroll {
//   0% {
//     opacity: 0;
//   }
//   100% {
//     opacity: 1;
//   }
// }
</style>
